import { render } from "./ComponentTree.vue?vue&type=template&id=e589fd86"
import script from "./ComponentTree.vue?vue&type=script&lang=js"
export * from "./ComponentTree.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__